import { Component, OnInit, OnDestroy, Inject, ViewChild, ComponentRef } from '@angular/core';

import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Subscription } from 'rxjs';

import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import * as moment from 'moment-timezone';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ProgressSpinnerComponent } from '../../common/progress-spinner/progress-spinner.component';

import { SpinnerService } from '../../services/spinner.service';
import { ConfigurationService } from '../../configuration.service';
import { ProjectLanguage } from '../../firestore-models/project-language';
import { ReservationFacility } from '../../firestore-models/reservation-facility';
import { ReservationFacilityAttribute } from '../../firestore-models/reservation-facility-attribute';
import { Reservation } from '../../firestore-models/reservation';
import { ReservationFacilitySpecial } from '../../firestore-models/reservation-facility-special';
import { GeneralText } from '../../firestore-models/general-text';
import { ConfirmReservationDetailDialogComponent } from '../confirm-reservation-detail-dialog/confirm-reservation-detail-dialog.component';
import { ApiClientService } from '../../api-client.service';
import { ApiSetReservationsStatusRequest, ApiSetLotteriesRequest, ApiLottery } from '../../api-client-module';


import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-confirm-reservation-dialog',
  templateUrl: './confirm-reservation-dialog.component.html',
  styleUrls: ['./confirm-reservation-dialog.component.css'],
  standalone: false,
})
export class ConfirmReservationDialogComponent implements OnInit, OnDestroy {
  projectLanguages!: Array<ProjectLanguage>;

  projectId: string;
  reservationsSubscribe!: Subscription;
  specialSubscribe!: Subscription;
  textsSubscribe!: Subscription;

  attrCollectionName = AppConst.FIRESTORE_RESERVATION_FACILITY_ATTR;

  displayedColumns: string[] = ['position', 'edit', 'reservation_no', 'company_name', 'name', 'email_address', 'reservation_start_date', 'reservation_end_date', 'reservation_status'];

  dataSource = new MatTableDataSource<Reservation>();
  selection = new SelectionModel<Reservation>(true, []);

  protected ATTR_SEARCH_WORD_PREFIX: string = 'reservationFacilityAttributes';
  reservationFacilityAttributes!: Array<ReservationFacilityAttribute>;
  facility: ReservationFacility;
  reservation: Reservation;

  reservations: Reservation[] = [];
  specials: ReservationFacilitySpecial[] = [];
  texts: GeneralText[] = [];

  searchFilter: any = {};
  capacity = 0;
  lotteryDate = '';

  spinner: ComponentRef<ProgressSpinnerComponent> | undefined;

  projectBaseLang: string = 'ja';

  @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;

  constructor(
    public dialogRef: MatDialogRef<ConfirmReservationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private angularFirestore: AngularFirestore,
    private configurationService: ConfigurationService,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private apiClientService: ApiClientService,
    private translate: TranslateService,
    private spinnerService: SpinnerService,
  ) {
      this.projectId = this.configurationService.getProjectId();
      this.facility = data.facility;
      this.reservation = data.reservation;
      moment.tz.setDefault('Asia/Tokyo');
      if (this.facility.reservation_method === AppConst.RESERVATION_METHOD_LOTTERY) {
        this.lotteryDate = moment(this.reservation.reservation_start_date.toDate()).add(-1 * this.facility.reservation_lottery_date, 'days').format('YYYY/MM/DD');
      }
    }

  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.projectLanguages = this.configurationService.getProject().languages!;
    // 汎用テキスト取得
    const textCollection = this.angularFirestore.collection<GeneralText>(
      AppConst.FIRESTORE_GENERAL_TEXTS, ref => ref);
    const textObservable = textCollection.valueChanges({ idField: 'id' });
    this.textsSubscribe = textObservable.subscribe(texts => {
      this.texts = texts;
    });

    const prefix = this.reservation.preview ? '' : '_stg';

    this.projectBaseLang = this.configurationService.getProject().project_base_lang;

    // 予約単位が期間
    if (this.facility.reservation_unit === AppConst.RESERVATION_UNIT_PERIOD) {
      const fromDate = moment(this.reservation.reservation_start_date.toDate()).add(this.facility.reservation_start_date * -1, 'days').toDate();       
      let toDate: Date;
      if (!!this.reservation.reservation_end_date) {
        toDate = this.reservation.reservation_end_date.toDate();
      } else {
        toDate = this.reservation.reservation_start_date.toDate();
      }
      const specialCollection = this.angularFirestore.collection<ReservationFacilitySpecial>(
        `${AppConst.FIRESTORE_RESERVATION_FACILITY_SPECIALS}${prefix}`, ref => ref.where('project_id', '==', this.projectId).where('reservation_facility_id', '==', this.reservation.reservation_facility_id).orderBy('reservation_special_start_date', 'asc'));
      const specialObservable = specialCollection.valueChanges({ idField: 'id' });
      this.specialSubscribe = specialObservable.subscribe(specials => {
        specials = specials.filter((special) => {

          console.log(`special.reservation_special_start_date: ${special.reservation_special_start_date!.toDate()}、 special.reservation_special_end_date: ${!!special.reservation_special_end_date ? special.reservation_special_end_date!.toDate() : null}`);
          console.log(`reservation.reservation_start_date: ${this.reservation.reservation_start_date!.toDate()}、 reservation.reservation_end_date: ${!!this.reservation.reservation_end_date ? this.reservation.reservation_end_date!.toDate() : null}`);
          // 特別営業日情報の終了日がなく、開始日が基準となる予約情報の利用日と一致
          if (!special.reservation_special_end_date && special.reservation_special_start_date!.toDate().getTime() == this.reservation.reservation_start_date.toDate().getTime()) {
            return true;
          }
          // 特別営業日情報の終了日があり、基準となる予約情報の利用日が開始日と終了日の間
          if (!!special.reservation_special_end_date && special.reservation_special_start_date!.toDate().getTime() <= this.reservation.reservation_start_date.toDate().getTime() && special.reservation_special_end_date.toDate().getTime() >= this.reservation.reservation_start_date.toDate().getTime()) {
            return true;
          }
          // 特別営業日情報の終了日がなく、開始日が基準となる予約情報の利用終了日と一致
          if (!special.reservation_special_end_date && !!this.reservation.reservation_end_date && special.reservation_special_start_date!.toDate().getTime() == this.reservation.reservation_end_date!.toDate().getTime()) {
            return true;
          }
          // 特別営業日情報の終了日があり、基準となる予約情報の利用終了日が開始日と終了日の間
          if (!!special.reservation_special_end_date && !!this.reservation.reservation_end_date && special.reservation_special_start_date!.toDate().getTime() <= this.reservation.reservation_end_date!.toDate().getTime() && special.reservation_special_end_date!.toDate().getTime() >= this.reservation.reservation_end_date!.toDate().getTime()) {
            return true;
          }
          return false;
        });

        if (this.reservationsSubscribe) {
          this.reservationsSubscribe.unsubscribe();
        }
        const resservationCollection = this.angularFirestore.collection<Reservation>(
          AppConst.FIRESTORE_RESERVATIONS, ref => ref.where('project_id', '==', this.projectId).where('reservation_facility_id', '==', this.reservation.reservation_facility_id).where('reservation_start_date', '>=', fromDate).where('reservation_start_date', '<=', toDate));
        const reservationObservable = resservationCollection.valueChanges({ idField: 'id' });
        this.reservationsSubscribe = reservationObservable.subscribe(reservations => {
          reservations = reservations.filter((reservation) => {
          // 対象環境が合っているか
            if (reservation.preview === this.reservation.preview) {
              // 予約情報の利用開始日が基準となる予約情報の利用開始日と利用終了日の範囲内にあるか
              if (reservation.reservation_start_date.toDate().getTime() >= this.reservation.reservation_start_date.toDate().getTime() && reservation.reservation_start_date.toDate().getTime() <= toDate.getTime()) {
                return true;
              }
              // 予約情報の利用終了日が基準となる予約情報の利用開始日と利用終了日の範囲内にあるか
              if (!!reservation.reservation_end_date && reservation.reservation_end_date.toDate().getTime() >= this.reservation.reservation_start_date.toDate().getTime() && reservation.reservation_end_date.toDate().getTime() <= toDate.getTime()) {
                return true;
              }
              // 基準となる予約情報の利用開始日が予約情報の利用開始日と利用終了日の範囲内にあるか
              if (!!reservation.reservation_end_date && reservation.reservation_start_date.toDate().getTime() <= this.reservation.reservation_start_date.toDate().getTime() && reservation.reservation_end_date.toDate().getTime() >= this.reservation.reservation_start_date.toDate().getTime()) {
                return true;
              }
              // 基準となる予約情報の利用終了日が予約情報の利用開始日と利用終了日の範囲内にあるか
              if (!!reservation.reservation_end_date && reservation.reservation_start_date.toDate().getTime() <= toDate.getTime() && toDate.getTime() <= reservation.reservation_end_date.toDate().getTime()) {
                return true;
              }
            }
            return false;
          });
          this.dataSource.data = reservations; 
        
          // 残予約数の計算
          let capacity = 0;
          const capacities: { [key: string]: number } = {};
          capacities[moment(this.reservation.reservation_start_date.toDate()).format('YYYYMMDD')] = 0;
          if (!!this.reservation.reservation_end_date) {
            let date = moment(this.reservation.reservation_start_date.toDate());
            while (date.isSameOrBefore(moment(this.reservation.reservation_end_date.toDate()))) {
              capacities[date.format('YYYYMMDD')] = 0;
              date = date.add(1, 'days');
            }
          }

          for (const key of Object.keys(capacities)) {
            let isExistSpecial = false;
            const date = moment(key, 'YYYYMMDD').toDate();
            // 該当する特別営業日情報の予約数を取得
            for (const special of specials) {
                if (!special.reservation_special_end_date && special.reservation_special_start_date!.toDate().getTime() == date.getTime()) {
                  for (const time of special.reservation_select_times) {
                    capacity = Number(time.value);
                  }
                  isExistSpecial = true;
                } else if (!!special.reservation_special_end_date && special.reservation_special_start_date!.toDate().getTime() <= date.getTime() && special.reservation_special_end_date!.toDate().getTime() >= date.getTime()) {
                  for (const time of special.reservation_select_times) {
                    capacity = Number(time.value);
                  }
                  isExistSpecial = true;
                }
              }
            // 特別営業日情報がない場合は設備の予約数を利用
            if (!isExistSpecial) {
              capacity = this.facility.reservation_count!;
            }
            capacities[key] = capacity;
          }

          // 確定済みの予約情報を取得
          const completeReservations = reservations.filter((reservation) => {
            return reservation.reservation_status === AppConst.RESERVATION_STATUS_COMPLETE;
          });

          for (const reservation of completeReservations) {
            if (!reservation.reservation_end_date) {
              const date = moment(reservation.reservation_start_date.toDate()).format('YYYYMMDD');
              if (!!capacities[date]) {
                capacities[date]--;
              }
            } else {
              let date = moment(reservation.reservation_start_date.toDate());
              while (date.isSameOrBefore(moment(reservation.reservation_end_date.toDate()))) {
                if (!!capacities[date.format('YYYYMMDD')]) {
                  capacities[date.format('YYYYMMDD')]--;
                }
                date = date.add(1, 'days');
              }
            }
          }

          let count = 0;
          for (const key of Object.keys(capacities)) {
            // 一番少ない空き予約枠を取得
            if (count === 0 || capacity > capacities[key]) {
              capacity = capacities[key];
            }
            count++;
          }
  
          this.capacity = capacity;
          this.reservations = reservations;
          this.specials = specials;
        })
      });

    // 予約単位が時間枠
    } else {
      const fromToDate = this.reservation.reservation_start_date.toDate();

      const specialCollection = this.angularFirestore.collection<ReservationFacilitySpecial>(
        `${AppConst.FIRESTORE_RESERVATION_FACILITY_SPECIALS}${prefix}`, ref => ref.where('project_id', '==', this.projectId).where('reservation_facility_id', '==', this.reservation.reservation_facility_id).orderBy('reservation_special_start_date', 'asc'));
      const specialObservable = specialCollection.valueChanges({ idField: 'id' });
      this.specialSubscribe = specialObservable.subscribe(specials => {
        specials = specials.filter((special) => {
          if (special.reservation_special_date_type === AppConst.RESERVATION_SPECIAL_DATE_TYPE_SPECIAL) {
            // 特別営業日情報の終了日がなく、開始日が抽選対象の予約情報の利用開始日と一致
            if (!special.reservation_special_end_date && special.reservation_special_start_date!.toDate().getTime() == fromToDate.getTime()) {
              return true;
            }
            // 特別営業日情報の開始日が予約情報の利用開始日以前かつ特別営業日情報の終了日が予約情報の利用開始日以降
            if (!!special.reservation_special_end_date && special.reservation_special_start_date!.toDate() <= fromToDate && special.reservation_special_end_date.toDate() >= fromToDate) {
              return true;
            }
          }
          return false;
        });

        if (this.reservationsSubscribe) {
          this.reservationsSubscribe.unsubscribe();
        }
        const resservationCollection = this.angularFirestore.collection<Reservation>(
          AppConst.FIRESTORE_RESERVATIONS, ref => ref.where('project_id', '==', this.projectId).where('reservation_facility_id', '==', this.reservation.reservation_facility_id).where('reservation_start_date', '>=', fromToDate).where('reservation_start_date', '<=', fromToDate));
        const reservationObservable = resservationCollection.valueChanges({ idField: 'id' });
        this.reservationsSubscribe = reservationObservable.subscribe(reservations => {
          reservations = reservations.filter((reservation) => {
            // 対象環境が合っているか
            if (reservation.preview === this.reservation.preview) {
              // 予約情報の利用時間が基準となる予約情報の利用時間と同じか
              if (reservation.reservation_times[0].index === this.reservation.reservation_times[0].index) {
                return true;
              }
            }
            return false;
          });
          this.dataSource.data = reservations; 
        
          // 残予約数の計算
          let capacity = 0;
          // 特別営業日情報がない場合は設備の予約数を利用
          if (specials.length === 0) {
            for (const time of this.facility.reservation_select_times) {
              if (time.index === this.reservation.reservation_times[0].index) {
                capacity = Number(time.value);
                break;
              }
            }
          // 特別営業日情報がある場合は特別営業日の予約数を利用
          } else {
            for (const time of specials[0].reservation_select_times) {
              if (time.index === this.reservation.reservation_times[0].index) {
                capacity = Number(time.value);
                break;
              }
            }
          }
  
          // 確定済みの予約情報を取得
          const completeReservations = reservations.filter((reservation) => {
            return reservation.reservation_status === AppConst.RESERVATION_STATUS_COMPLETE;
          });
          capacity -= completeReservations.length;
  
          this.capacity = capacity;
          this.reservations = reservations;
          this.specials = specials;
        })

      });
    }
  }

  ngOnDestroy(): void {
    this.reservationsSubscribe.unsubscribe();
    this.specialSubscribe.unsubscribe();
    this.textsSubscribe.unsubscribe();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  sortData(sort: Sort) {
    const data = this.dataSource.data.slice();
    if (!sort.active || sort.direction === '') {
      this.dataSource.data = data;
      return;
    }
    const compare = (a: number | string, b: number | string, isAsc: boolean) => {
      return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }

    this.dataSource.data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'name':
          const aName = (!!a.family_name ? a.family_name : '') + (!!a.first_name ? a.first_name : '');
          const bName = (!!b.family_name ? b.family_name : '') + (!!b.first_name ? b.first_name : '');
          return compare(aName, bName, isAsc);
        default:
          return 0;
      }
    });
  }

  addFilterValue(docs: Array<any>) :Array<any> {
    for (const doc of docs) {
      let filterValue = '';
      for (const value of doc.reservation_facility_names) {
        filterValue += value.name + ' '
      }
      doc['filterValue'] = filterValue;
      doc['filterValueAttr'] = this.ATTR_SEARCH_WORD_PREFIX + doc.reservation_facility_attribute_id;
    }
    return docs;
  }

  openDialog(reservation: Reservation): void {
    let curReservationFacility = this.facility;
    const dialogRef = this.dialog.open(ConfirmReservationDetailDialogComponent, {
      width: '85%',
      disableClose: true,
      data: { reservation: reservation, reservationFacility: curReservationFacility }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.spinnerService.openSpinner();
        const request = {
          project_id                : this.projectId,
          reservation_facility_id   : reservation.reservation_facility_id,
          reservation_no            : reservation.reservation_no,
          reservation_status        : result.reservation_status, 
          memo                      : result.memo, 
        } as ApiSetReservationsStatusRequest;
        this.apiClientService.setReservationsStatus(request).then(
          response => {
            if (response!.ret === AppConst.API_RET_SUCCESS) {
              this.toastr.success(this.translate.instant('予約状況を更新しました。'));
            } else if (response!.ret === AppConst.API_RET_NOT_VACANT_RESERVATION) {
              this.toastr.success(this.translate.instant('空き予約枠がないため、予約状況を確定に更新できませんでした。'), '', { timeOut : 5000 });
            } else {
              this.toastr.error(this.translate.instant('予約状況を更新できませんでした。'), '', { timeOut : 5000 });
            }
          }
        ).catch(
          error => {
            console.log(error);
            this.toastr.error(this.translate.instant('予約状況を更新できませんでした。'), '', { timeOut : 5000 });
          }
        ).finally(
          () => {
            this.spinnerService.closeSpinner();
          }
        );
      }
    });
  }

  lottery(): void {
    this.spinnerService.openSpinner();
    const completeReservations = this.reservations.filter((reservation) => {
      return reservation.reservation_status === AppConst.RESERVATION_STATUS_COMPLETE;
    });
    const value = this.capacity + completeReservations.length;
    let index = !!this.reservation.reservation_times && this.reservation.reservation_times.length > 0 ?  this.reservation.reservation_times[0].index : null;
    const request = {
      change_type: AppConst.DATA_CHANGE_TYPE_ADD,  
      lotteries: [
        {
          project_id                : this.projectId,
          reservation_facility_id   : this.reservation.reservation_facility_id,
          preview                   : this.reservation.preview,
          reservation_start_date    : this.reservation.reservation_start_date.toDate(),
          reservation_times_index   : index, 
          reservation_times_value   : value, 
        } as ApiLottery
      ]
    } as ApiSetLotteriesRequest;
    this.apiClientService.setLotteries(request).then(
      response => {
        if (response!.ret === AppConst.API_RET_SUCCESS) {
          this.toastr.success(this.translate.instant('抽選情報を登録しました。'));
        } else {
          this.toastr.error(this.translate.instant('抽選情報を登録できませんでした。'), '', { timeOut : 5000 });
        }
      }
    ).catch(
      error => {
        console.log(error);
        this.toastr.error(this.translate.instant('抽選情報を登録できませんでした。'), '', { timeOut : 5000 });
      }
    ).finally(
      () => {
        this.spinnerService.closeSpinner();
      }
    );
  }
}
